import { useAuth } from "@/context/AuthContext";
import ResetTile from "@/components/routine/ResetTile";
import { useResetLibrary, MOOD_RESET } from "@/lib/resets";

export default function GoToReset({ feeling }) {
  const { user } = useAuth();
  const lib = useResetLibrary() || [];
  const fav = user?.profile?.favourite_reset;
  const tense = !!MOOD_RESET[feeling];
  const r = lib.find((x) => x.id === fav) || (tense ? lib.find((x) => x.id === MOOD_RESET[feeling]) : null);
  if (!r) return null;
  return (
    <ResetTile reset={r} highlight={tense} eyebrow={r.id === fav ? "Your go-to reset" : "A reset for right now"}
      offer={tense ? `${feeling === "Tense" ? "Feeling tense?" : "Overthinking?"} Let's do ${r.title} together first.` : null}
      link={r.id === fav ? "Change" : "Pick a go-to"} />
  );
}

const PLAN_LABEL = { zoom: "Zoom call", call: "call", date: "date", interview: "interview", pitch: "pitch", presentation: "presentation", meeting: "meeting" };

export function PlanReset({ plan }) {
  const lib = useResetLibrary() || [];
  const r = plan && lib.find((x) => x.id === plan.reset);
  if (!r) return null;
  return (
    <ResetTile reset={r} highlight testid="routine-plan-reset" eyebrow="Ready for later today"
      offer={`Your ${PLAN_LABEL[plan.what] || plan.what} later today. ${r.title} is ready whenever you want it, just before.`} />
  );
}

export function SmileStart({ feeling }) {
  const lib = useResetLibrary() || [];
  const r = ["Open", "Magnetic"].includes(feeling) && lib.find((x) => x.id === "smile");
  if (!r) return null;
  return <ResetTile reset={r} testid="routine-smile-start" eyebrow="Start with a smile" offer={`A light minute to begin the day feeling ${feeling.toLowerCase()}.`} />;
}
